import UnitOfCurrencySelect from './UnitOfCurrencySelect';

export default UnitOfCurrencySelect;
